import React from 'react';
import StationClient from '#/lib/StationClient';
import MassiveDownloadSection from "#/backoffice/pages/MassiveDownloadSection";
import { Button, Card, Modal } from 'react-bootstrap';


export default class MassiveDownloadPage extends React.Component {
	constructor(props) {
		super(props);
		const tipo = this.getTipoFromProps(props);
		this.state = {
			stationsGeoJSON : null,
			interval : null,
			selectedMeasure : null,
			selectedStation : null,
			tipoRichiesta: tipo,
			showModal: tipo === "non-validati"
		}
	}

	getTipoFromProps = (props = this.props) => {
		const params = new URLSearchParams(props.location?.search || "");
		return params.get("tipo");
	}

	componentDidMount(){
		StationClient.getStationsGeojson(
			(data)=>{
				this.setState({
					stationsGeoJSON : data
				})
			},
			(err) => {console.log(err)}

		)

	}

	componentDidUpdate(prevProps) {
		const prevTipo = this.getTipoFromProps(prevProps);
		const nextTipo = this.getTipoFromProps(this.props);

		if (prevTipo !== nextTipo) {
			this.setState({
				tipoRichiesta: nextTipo,
				showModal: nextTipo === "non-validati"
			});
		}
	}

    openModal = () => {
        this.setState({showModal: true});
    }

    onCloseModal = () => {
        this.setState({showModal: false});
    }

	render() {
		if (!!this.state.stationsGeoJSON){
			return <div className="generic-page container-fluid data-page">
				{
					this.state.tipoRichiesta === "non-validati" ?
					<Modal show={this.state.showModal} onHide={this.onCloseModal} centered backdrop="static">
						<Modal.Header closeButton style={{border: 'none'}}>
						</Modal.Header>
						<Modal.Body>
							<Card className="border-0 shadow-none">
								<Card.Body className="p-0">
									<Card.Text>
										Per una mole esigua di dati si rimanda alla Home nella sezione “In primo piano” per la consultazione del documento “istruzioni per la consultazione dati”, per download massivi usare l’export dati
									</Card.Text>
									<div className="d-flex justify-content-end">
										<Button variant="primary" onClick={this.onCloseModal}>
											Chiudi
										</Button>
									</div>
								</Card.Body>
							</Card>
						</Modal.Body>
					</Modal>
					: <></>
				}
				{
					this.state.tipoRichiesta === "non-validati" ?
					<strong className="row col-12 justify-content-center align-items-center note">
						I dati non sono validati e potrebbero contenere errori
					</strong> : <></>
				}
				{
					this.state.tipoRichiesta === "certificati" ?	
					<strong className="row col-12 justify-content-center align-items-center note">
						Le richieste non possono superare un certo numero di dati e saranno evase entro 30 giorni
					</strong> : <></>
				}
				<span>Seleziona uno o più dei criteri sottostanti</span>
				<MassiveDownloadSection
					stationsGeoJSON = {this.state.stationsGeoJSON}
					selectedZone = {this.state.selectedZone}
					selectedStation = {this.state.selectedStation}
					selectedMeasure = {this.state.selectedMeasure}
				></MassiveDownloadSection>
			</div>
		} else return <div className="generic-page container-fluid data-page"></div>

	}
}
